import {
  eventProps,
  setAnalyticsUserProperties,
  trackEvent as globalTrackEvent,
} from '../../../utils/analytics/analytics';
import { useTypedSelector } from '../../store/store';
import { getEnvelope, getUserProperties } from '../../services/analytics/telemetry';
import { V2_EVENT_NAMES } from '../constants/constants';

export type IEventTracker = (props: eventProps) => void;

export const useTrackEvent = () => {
  const { id: meId, accountId: meAccountId } = useTypedSelector((state) => state.me);
  // The `me` slice only carries these on some login paths; the account slice
  // and the stored user id are the reliable sources for the creator flow.
  const accountSliceId = useTypedSelector((state) => state.account.account.id);
  const accountId = meAccountId || accountSliceId || '';
  const creatorId = meId || (typeof localStorage !== 'undefined' ? localStorage.getItem('userId') || '' : '');
  const { shareStory } = useTypedSelector((state) => state.stories);
  const campaignId = useTypedSelector((state) => state.rewards.currentCampaign?.id ?? null);
  // A/B variant for the creator flow, when an account sets one.
  const flow = useTypedSelector(
    (state) =>
      (state.account.accountAttributes.properties as { 'webapp.config'?: { flow?: string } } | undefined)?.[
        'webapp.config'
      ]?.flow ?? null,
  );

  const trackEvent: IEventTracker = (props) => {
    // Session-level values go out as user properties, not on every event.
    setAnalyticsUserProperties(getUserProperties({ campaign_id: campaignId, flow }));
    const v2 = V2_EVENT_NAMES.has(props.action);
    globalTrackEvent({
      // Legacy events keep `location` (existing dashboards use it); v2 events
      // rely on GA4's own page_location.
      ...(v2 ? {} : { location: window.location.href }),
      accountId,
      ...(shareStory?.id ? { videoId: shareStory.id } : {}),
      ...(creatorId ? { creatorId } : {}),
      ...getEnvelope(),
      ...props,
      v2,
    });
  };

  return { trackEvent };
};
